import { Box } from "@mui/material"
import { DamsAppAsset } from "../../assets/registry";
import { MainPageBase } from "../page-bases/MainPageBase";


function SettingsMainPage() {
    return (
        <MainPageBase
            title="Settings"
            subtitle="Manage your Profile in DAMS"
            pageState="main">
            <Box
                height={`100%`}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
            >
                <Box>
                    <img
                        src={DamsAppAsset.image.under_construction}
                        width={200}
                        height={200} />
                </Box>

            </Box>
        </MainPageBase>

    )
}

export default SettingsMainPage;
